import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './login/shared/auth.guard';
import { AdminGuard } from './login/shared/admin.guard';
import { LeaderGuard } from './login/shared/leader.guard';

import { AuthenticateComponent } from "./authenticate/authenticate.component";
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { AttendanceStatusComponentV1 } from './attendance-status-v1/attendance-status-v1.component';
import { AttendanceStatusComponent } from './attendance-status/attendance-status.component';
import { StaffListResolver } from './attendance-status/stafflist-resolver.service';
import { GroupListResolver } from './attendance-status/grouplist-resolver.service';

import { BreaktimeCebuResolver } from './breaktime-cebu/shared/breaktime-cebu.resolver';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/attendance-record',
        pathMatch: 'full'
    },
    { path: 'authenticate', component: AuthenticateComponent },
    { path: 'unauthorized', component: UnauthorizedComponent },
    {
        path: 'template-settings',
        loadChildren: 'app/template-set/template-set.module#TemplateSetModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'indi-settings',
        loadChildren: 'app/indi-set/indi-set.module#IndiSetModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'attendance-record',
        loadChildren: 'app/attendance-record/attendance-record.module#AttendanceRecordModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'basic-settings',
        loadChildren: 'app/basic-settings/basic-settings.module#BasicSettingsModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'dashboard',
        loadChildren: 'app/dashboard/dashboard.module#DashboardModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'unavailable-list',
        loadChildren: 'app/unavailable-list/unavailable-list.module#UnavailableListModule'
    },
    {
        path: 'workrec-list',
        loadChildren: 'app/workrec-list/workrec-list.module#WorkRecListModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'alert-application',
        loadChildren: 'app/alert-application/alert-application.module#AlertApplicationModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'attendance-list',
        loadChildren: 'app/attendance-list/attendance-list.module#AttendanceListModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'timestamp-cebu',
        loadChildren: 'app/timestamp-cebu/timestamp-cebu.module#TimestampCebuModule',
        canActivate: [AuthGuard]
    },
    // {
    //     path: 'breaktime-cebu',
    //     loadChildren: 'app/breaktime-cebu/breaktime-cebu.module#BreaktimeCebuModule',
    //     canActivate: [AuthGuard],
    //     resolve: {
    //         data: BreaktimeCebuResolver
    //     }
    // },
    {
        path: 'cebu-vacations',
        loadChildren: 'app/cebu-vacations/cebu-vacations.module#CebuVacationsModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'reports',
        loadChildren: 'app/reports/reports.module#ReportsModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'schedule-calendar',
        loadChildren: 'app/schedule-calendar/schedule-calendar.module#ScheduleCalendarModule',
        canActivate: [AuthGuard]
    },
    // {
    //     path: 'attendance-status-new',
    //     component: AttendanceStatusComponent,
    //     canActivate: [AuthGuard]
    // },
    {
        path: 'attendance-status',
        component: AttendanceStatusComponent,
        canActivate: [AuthGuard],
        resolve: {
            staffs: StaffListResolver,
            groups: GroupListResolver
        }
    },
    {
        path: '**',
        redirectTo: '/attendance-record',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
